module.exports = __webpack_public_path__ + "static/media/logo2.d7589e3a.svg";